import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import c from 'classnames';
import { colors, globals } from '../../styles';
import Props from './props';

class PrimaryButton extends React.Component<Props, any> {
  static defaultProps: Partial<Props> = {
    type: 'button',
  };

  render() {
    const { children, className, disabled, full, onClick, type } = this.props;
    const propsWoutBools = { ...this.props };
    delete propsWoutBools.full;

    return (
      <button
        {...propsWoutBools}
        type={type}
        className={c(className, { 'full-width': full, disabled })}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }
}

const StyledPrimaryButton = styled(PrimaryButton)`
  ${globals.button};

  background: ${colors.green500};
  border: 1px solid ${colors.green700};
  color: white;
  padding: 0;
  width: 10rem;
  height: 2rem;

  :hover {
    background: ${colors.green400};
    box-shadow: 0 4px 6px 0 rgba(47, 137, 50, 0.15);
    border: 1px solid ${colors.green500};
  }
`;

export default StyledPrimaryButton;
